import { escapeHtml } from './html'
import { getPlanPalette } from './plan-badge'

// Aceita o CÓDIGO do plano ou o nome de exibição: este HTML é montado a partir de
// payload de webhook, que ainda traz o nome.
export function planBadgePalette (planCodeOrDisplayName) {
  return getPlanPalette(planCodeOrDisplayName)
}

export function planBadgeStyle (planCodeOrDisplayName) {
  const palette = getPlanPalette(planCodeOrDisplayName)
  return `background-color: ${palette.background}; color: ${palette.text}; border: 1px solid ${palette.border}; padding: 2px 8px; border-radius: 9999px; font-size: 11px; font-weight: 600;`
}

function formatCell (v) {
  return v != null && String(v).trim() !== '' ? escapeHtml(String(v).trim()) : '—'
}

function renderPlanBadge (plan) {
  if (!plan || String(plan).trim() === '') return '—'
  const p = String(plan).trim()
  const style = planBadgeStyle(p)
  return `<span style="${style}">${escapeHtml(p)}</span>`
}

function renderAccessBadge (accessType) {
  if (!accessType || String(accessType).trim() === '') return '—'
  const a = String(accessType).trim()
  const style = planBadgeStyle(null)
  return `<span style="${style}">${escapeHtml(a)}</span>`
}

function formatBeforeAfter (before, after) {
  const b = before != null && String(before).trim() !== '' ? String(before).trim() : null
  const a = after != null && String(after).trim() !== '' ? String(after).trim() : null
  if (!b && !a) return '—'
  if (!b) return escapeHtml(a)
  if (!a) return escapeHtml(b)
  if (b === a) return escapeHtml(a)
  return `<span style="color: #9ca3af;">${escapeHtml(b)}</span> → <span>${escapeHtml(a)}</span>`
}

function formatBeforeAfterPlan (before, after) {
  const b = before != null && String(before).trim() !== '' ? String(before).trim() : null
  const a = after != null && String(after).trim() !== '' ? String(after).trim() : null
  if (!b && !a) return '—'
  if (!b) return renderPlanBadge(a)
  if (!a) return renderPlanBadge(b)
  if (b === a) return renderPlanBadge(a)
  return `<span style="color: #9ca3af;">${escapeHtml(b)}</span> → ${renderPlanBadge(a)}`
}

const TH = 'padding: 12px; text-align: center; border: 1px solid #e5e7eb; font-weight: 600;'
const TD = 'padding: 8px; text-align: left; border: 1px solid #e5e7eb; font-size: 13px;'
const TD_C = 'padding: 8px; text-align: center; border: 1px solid #e5e7eb; font-size: 13px;'

export function generateInviteEmailHtml (data) {
  const org = data && data.organizationName != null ? String(data.organizationName) : ''
  const domain = data && data.organizationDomain != null ? String(data.organizationDomain) : ''
  const userEmail = data && data.userEmail != null ? String(data.userEmail) : ''
  const userName = data && data.userName != null ? String(data.userName) : ''
  const plan = data && data.plan != null ? String(data.plan) : null
  const accessType = data && data.accessType != null ? String(data.accessType) : ''
  const admin = data && data.adminEmail != null ? String(data.adminEmail) : ''

  const adminLabel = admin.trim() ? escapeHtml(admin) : '—'

  const html = `
    <div style="width: 100%; font-family: sans-serif; margin-bottom: 16px;">
      <h1 style="text-align: center; font-size: 24px; font-weight: 600; margin: 0 0 8px 0;">Novo usuário convidado à plataforma</h1>
      <p style="text-align: center; font-size: 16px; font-weight: 400; margin: 0; color: #374151;">${org ? escapeHtml(org) : '—'}${domain ? ' (' + escapeHtml(domain) + ')' : ''}</p>
      <p style="text-align: center; font-size: 14px; color: #6b7280; margin: 8px 0 0 0;">Admin que convidou: ${adminLabel}</p>
    </div>
    <table style="width: 100%; border-collapse: collapse; border: 1px solid #e5e7eb; font-family: sans-serif;">
      <thead>
        <tr style="background-color: #f9fafb; border-bottom: 2px solid #e5e7eb;">
          <th style="${TH}">Domínio</th>
          <th style="${TH}">Organização</th>
          <th style="${TH}">E-mail</th>
          <th style="${TH}">Nome</th>
          <th style="${TH}">Plano</th>
          <th style="${TH}">Tipo de acesso</th>
          <th style="${TH}">Admin</th>
        </tr>
      </thead>
      <tbody>
        <tr style="background-color: #f9fafb;">
          <td style="${TD}">${formatCell(domain)}</td>
          <td style="${TD}">${formatCell(org)}</td>
          <td style="${TD}">${formatCell(userEmail)}</td>
          <td style="${TD}">${formatCell(userName)}</td>
          <td style="${TD_C}">${renderPlanBadge(plan)}</td>
          <td style="${TD_C}">${renderAccessBadge(accessType)}</td>
          <td style="${TD}">${adminLabel}</td>
        </tr>
      </tbody>
    </table>
  `
  return html.trim()
}

export function generateUserChangesEmailHtml (data) {
  const org = data && data.organizationName != null ? String(data.organizationName) : ''
  const domain = data && data.organizationDomain != null ? String(data.organizationDomain) : ''
  const userEmail = data && data.userEmail != null ? String(data.userEmail) : ''
  const userName = data && data.userName != null ? String(data.userName) : ''
  const statusBefore = data && data.statusBefore != null ? String(data.statusBefore).trim() : null
  const statusAfter = data && data.statusAfter != null ? String(data.statusAfter).trim() : null
  const planBefore = data && data.planBefore != null ? String(data.planBefore).trim() : null
  const planAfter = data && data.planAfter != null ? String(data.planAfter).trim() : null
  const admin = data && data.adminEmail != null ? String(data.adminEmail) : ''

  const adminLabel = admin.trim() ? escapeHtml(admin) : '—'
  const userLabel = (userName && userName.trim()) ? escapeHtml(userName.trim()) + ' &lt;' + escapeHtml(userEmail) + '&gt;' : escapeHtml(userEmail)
  const statusChanged = (statusBefore || statusAfter) && statusBefore !== statusAfter
  const planChanged = (planBefore || planAfter) && planBefore !== planAfter

  const boxStyle = 'border: 1px solid #e5e7eb; border-radius: 8px; padding: 1rem 1.25rem; margin-bottom: 1rem; background-color: #fafafa;'
  const titleStyle = 'font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: #6b7280; margin: 0 0 8px 0;'
  const valueStyle = 'font-size: 15px; font-weight: 600; color: #111827; margin: 0;'

  let sectionsHtml = ''
  if (statusChanged) {
    const statusDisplay = formatBeforeAfter(statusBefore, statusAfter)
    sectionsHtml += `
    <div style="${boxStyle}">
      <p style="${titleStyle}">Mudança de status</p>
      <p style="${valueStyle}">${statusDisplay}</p>
    </div>`
  }
  if (planChanged) {
    const planDisplay = formatBeforeAfterPlan(planBefore, planAfter)
    sectionsHtml += `
    <div style="${boxStyle}">
      <p style="${titleStyle}">Mudança de plano</p>
      <p style="${valueStyle}">${planDisplay}</p>
    </div>`
  }
  if (!sectionsHtml) {
    sectionsHtml = `<div style="${boxStyle}"><p style="${valueStyle}">— Nenhuma alteração de status ou plano informada.</p></div>`
  }

  const html = `
    <div style="width: 100%; font-family: sans-serif; max-width: 560px;">
      <h1 style="text-align: center; font-size: 22px; font-weight: 600; margin: 0 0 16px 0; color: #111827;">Alteração de usuário</h1>
      <table style="width: 100%; border-collapse: collapse; border: 1px solid #e5e7eb; font-family: sans-serif; margin-bottom: 20px;">
        <tbody>
          <tr><td style="${TD}"><strong>Organização</strong></td><td style="${TD}">${formatCell(org)}</td></tr>
          <tr style="background-color: #f9fafb;"><td style="${TD}"><strong>Domínio</strong></td><td style="${TD}">${formatCell(domain)}</td></tr>
          <tr><td style="${TD}"><strong>Usuário</strong></td><td style="${TD}">${userLabel}</td></tr>
          <tr style="background-color: #f9fafb;"><td style="${TD}"><strong>Admin que alterou</strong></td><td style="${TD}">${adminLabel}</td></tr>
        </tbody>
      </table>
      <p style="font-size: 12px; font-weight: 600; color: #6b7280; margin: 0 0 8px 0;">Tipos de alteração:</p>
      ${sectionsHtml}
    </div>
  `
  return html.trim()
}



// WEBPACK FOOTER //
// ./src/utils/emailHtml.js